import ApplyMembershipModal from "../../components/ApplyMembershipModal";

export function MembershipIntro() {
  return (
    <section className="pt-16 rise" data-testid="membership-intro">
      <span className="t-label">For potential members</span>
      <h1 className="text-bone mt-4 measure" style={{ fontSize: "clamp(30px, 4vw, 48px)", lineHeight: 1.16, fontWeight: 400, letterSpacing: "-0.01em" }}>
        One surface for the people who buy, and the people who sell.
      </h1>
      <p className="t-small text-muted-s mt-5 measure">
        Solera serves both sides of a private transaction. Buyers see what is theirs and what is on offer.
        Sellers bring us a position and we confirm it with the issuer before any price is discussed. This is
        what the membership looks like from the inside.
      </p>
      <div className="mt-8">
        <ApplyMembershipModal trigger={
          <button className="btn-primary inline-block" data-testid="membership-hero-apply">Apply for membership</button>
        } />
      </div>
    </section>
  );
}
